// @ts-ignore
import React from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { deleteOrg, deleteUser, settingTrue } from '../../../redux/actions';
import './Sidebar.css';
import DonorProfile from '../../navbar/donorModals/DonorProfile';
import SettingsModal from './SettingsModal';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  // events (v5)
  faQuestionCircle,      // help (v5)
  faChevronDown,
  faExternalLinkAlt,
  faEnvelope,     // external link (v5)
} from '@fortawesome/free-solid-svg-icons';

interface NavItemSub {
  id: string;
  label: string;
  path?: string;
  active: boolean;
  external?: boolean;
  hasSubmenu?: boolean;
}
interface NavItem {
  id: string;
  label: string;
  icon: React.ReactNode;     // JSX icon
  path?: string;
  active: boolean;
  external?: boolean;
  hasSubmenu?: boolean;
  subitems?: NavItemSub[];
  action?: boolean;
  disable?: boolean;
}

interface SidebarProps {
  collapsed: boolean;
  mobileOpen: boolean;
  onMobileToggle: () => void;
  onToggle: () => void;
  userRole?: string;
  isMobile?: boolean;
  setMobileMenuOpen?: any;
  onMobileManageDonations?: () => void;
  onMobileManageStore?: () => void;
  onMobileManageWishlist?: () => void;
  // showSettingsModal? : boolean;
  // setShowSettingsModal?:any
}

const Sidebar: React.FC<SidebarProps> = ({
  collapsed,
  mobileOpen,
  setMobileMenuOpen,
  onToggle,
  onMobileToggle,
  userRole = 'nonprofit',
  isMobile = false,
  onMobileManageDonations,
  onMobileManageStore,
  onMobileManageWishlist,
  // showSettingsModal,
  // setShowSettingsModal
}) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const reduxOrg = useSelector((state: any) => state.org);
  const reduxUser = useSelector((state: any) => state.signin);
  const [openDropdowns, setOpenDropdowns] = React.useState<Set<string>>(new Set());
  const [showDonorProfileModal, setShowDonorProfileModal] = React.useState<boolean>(false);
  const setting = useSelector((state: any) => state.setting);
  // const [showSettingsModal, setShowSettingsModal] = React.useState<boolean>(false);

  const logout = () => {
    dispatch(deleteUser());
    dispatch(deleteOrg());
    history.push('/');
  };

  const handleProfileClick = () => {
    setShowDonorProfileModal(true);
  };

  const handleCloseDonorProfileModal = () => {
    setShowDonorProfileModal(false);
  };

  // const handleSettingsClick = () => {
  //   setShowSettingsModal(true);
  // };

  // const handleCloseSettingsModal = () => {
  //   setShowSettingsModal(false);
  // };

  const handleSaveSettings = async (settingsData: any) => {
    // TODO: Implement API call to save settings
    console.log('Saving settings:', settingsData);
  };

  const png = (src: string, alt: string) => (
    <img src={src} alt={alt} className="nav-img" loading="lazy" />
  );

  const getNavigationItems = (): NavItem[] => {
    const baseItems: NavItem[] = [
      {
        id: 'dashboard',
        label: 'Dashboard',
        icon: png('/icons/1.png', 'dashboard'),
        path: '/dashboard',
        active: location.pathname === '/dashboard'
      }
    ];

    const individualItems: NavItem[] = [
      {
        id: 'profile',
        label: 'Profile',
        // label: 'My Profile',
        icon: png('/icons/3.png', 'Profile'),
        active: showDonorProfileModal || location.pathname.includes('/donor/'),
        disable: false,
      },
      // {
      //   id: 'neddie-page',
      //   label: 'NEDDIE page',
      //   icon: png('/icons/3.png', 'Profile'),
      //   path: '/donor-profile',
      //   active: location.pathname === '/donor-profile'
      // },
      {
        id: 'search-charities',
        label: 'Search Charities',
        icon: png('/icons/5.png', 'Search Charities'),
        path: '/search',
        active: location.pathname === '/search',
        disable: false,
      },
      {
        id: 'donation-history',
        label: 'Donation History',
        icon: png('/icons/4.png', 'Search Charities'),
        path: `/donor/${reduxUser?._id}`,
        active: location.pathname.includes('/donor/') && location.pathname.includes('donations'),
        disable: false,
      },
      {
        id: 'recurring-donations',
        label: 'Recurring Donations',
        icon: png('/icons/recurringDonations.svg', 'Recurring Donations'),
        path: '/recurring-donations',
        active: location.pathname === '/recurring-donations',
        disable: false,
      },
      // {
      //   id: 'for-donors',
      //   label: 'For Donors',
      //   icon: png('/icons/4.png', 'Search Charities'),
      //   path: 'https://www.neddieblog.com/for-donors',
      //   external: true,
      //   active: false
      // },
      {
        id: 'charities-i-love',
        label: 'Charities I Love',
        icon: png('/icons/charitiesILove.svg', 'charitiesILove'),
        path: 'https://www.neddieblog.com/',
        external: false,
        active: false,
        disable: true,
      },
      {
        id: 'my-fundraisers',
        label: 'My Fundraisers',
        icon: png('/icons/myFundraisers.svg', 'MyFundraisers'),
        path: '/my-fundraisers',
        external: false,
        active: location.pathname === '/my-fundraisers',
        disable: false,
      },
      {
        id: 'community-fundraisers',
        label: 'Community Fundraisers',
        icon: png('/icons/communityFundraisers.svg', 'communityFundraisers'),
        path: 'https://www.neddieblog.com/',
        external: false,
        active: false,
        disable: true,
      },
      {
        id: 'porpose-match',
        label: 'Purpose Match',
        icon: png('/icons/purposeMatch.svg', 'purposeMatch'),
        path: 'https://www.neddieblog.com/purpose-match',
        external: true,
        active: false,
        disable: false,
      },
      {
        id: 'resources',
        label: 'Resources',
        icon: png('/icons/10.png', 'Resources'),
        path: 'https://www.neddieblog.com/',
        external: true,
        active: false,
        disable: false,
      },
      {
        id: 'settings',
        label: 'Settings',
        icon: png('/icons/11.png', 'settings'),
        path: '',
        active: location.pathname === '/dashboard/settings',
        disable: false,
      }
    ];

    const nonprofitItems: NavItem[] = [
      {
        id: 'profile',
        label: 'My Profile',
        icon: png('/icons/3.png', 'Profile'),
        path: `/nonprofit/${reduxOrg?._id}`,
        active: location.pathname.includes('/nonprofit/')
      },
      {
        id: 'payments',
        label: 'Connect Payments',
        icon: png('/icons/2.png', 'payments'),
        path: '/connect-payments',
        active: location.pathname === '/connect-payments'
      },
      {
        id: 'donations',
        label: 'Manage Donations',
        icon: png('/icons/manage_donations.svg', 'Donations'),
        path: '/manage-pay',
        active: location.pathname === '/manage-pay'
      },
      {
        id: 'grants',
        label: 'Grant Central',
        icon: png('/icons/5.png', 'Grant Central'),
        hasSubmenu: true,
        active: false,
        subitems: [
          {
            id: 'grant-central',
            label: 'Grant Central',
            path: 'https://www.neddieblog.com/grant-central-faqs',
            external: true,
            active: false
          },
          {
            id: 'grant-search',
            label: 'Search Grants',
            path: 'https://www.neddieblog.com/grant-central-search',
            external: true,
            active: false
          },
          {
            id: 'my-subscription',
            label: 'My Subscription',
            path: 'https://www.neddieblog.com/account/my-subscriptions',
            external: true,
            active: false
          },
          {
            id: 'plans-&-pricing',
            label: 'Plans & Pricing',
            path: 'https://www.neddieblog.com/plans-pricing',
            external: true,
            active: false
          },
          // {
          //   id: 'grant-resources',
          //   label: 'Grant Resources',
          //   path: 'https://www.neddieblog.com/grant-central-faqs',
          //   external: true,
          //   active: false
          // }
        ]
      },
      {
        id: 'neddie-integration',
        label: 'NEDDIE Integration',
        icon: png('/icons/neddie_integeration.svg', 'neddie-integration'),
        path: '/neddie-integration',
        active: location.pathname === '/neddie-integration'
      },
      {
        id: 'wishlist',
        label: 'Manage Wishlist',
        icon: png('/icons/6.png', 'wishlist'),
        path: '/manage-wishlist',
        active: location.pathname === '/manage-wishlist'
      },
      {
        id: 'store',
        label: 'Manage Store',
        icon: png('/icons/7.png', 'Manage Store'),
        path: '/manage-store',
        active: location.pathname === '/manage-store'
      },
      // {
      //   id: 'forum',
      //   label: 'Community Forum',
      //   icon: png('/icons/8.png', 'Community Forum'),
      //   hasSubmenu: true,
      //   active: false,
      //   subitems: [
      //     {
      //       id: 'main-forum',
      //       label: 'Main Forum',
      //       path: 'https://www.neddieblog.com/neddie-forum',
      //       external: true,
      //       active: false
      //     },
      //     {
      //       id: 'discussion-forum',
      //       label: 'Discussion Board',
      //       path: 'https://www.neddieblog.com/neddie-forum/discussions',
      //       external: true,
      //       active: false
      //     }
      //   ]
      // },
      {
        id: 'events',
        label: 'NEDDIE Events',
        icon: png('/icons/9.png', 'NEDDIE Events'),
        path: 'https://www.neddieblog.com/neddie-events',
        active: location.pathname === '/dashboard/events',
        external: true,
      },
      {
        id: 'resources',
        label: 'Resources',
        icon: png('/icons/10.png', 'Resources'),
        path: 'https://www.neddieblog.com/',
        external: true,
        active: false
      },
      {
        id: 'settings',
        label: 'Settings',
        icon: png('/icons/11.png', 'settings'),
        path: '/settings',
        active: location.pathname === '/settings'
      },
      {
        id: 'help',
        label: 'Help',
        icon: png('/icons/12.png', 'Help'),
        path: '/help',
        active: location.pathname === '/help'
      },
      {
        id: 'contact',
        label: 'Contact Us',
        icon: png('/icons/13.png', 'Contact Us'),
        path: 'https://www.neddieblog.com/contact',
        external: true,
        active: false
      }
    ];

    return userRole === 'individual'
      ? [...baseItems, ...individualItems]
      : [...baseItems, ...nonprofitItems];
  };

  const navigationItems = getNavigationItems();

  const handleNavClick = (item: NavItem) => {
    if (item.hasSubmenu) {
      setOpenDropdowns(prev => {
        const s = new Set(prev);
        s.has(item.id) ? s.delete(item.id) : s.add(item.id);
        return s;
      });
      return;
    }

    // Special handling for profile item to open modal
    if (item.id === 'profile' && userRole === 'individual') {
      handleProfileClick();
      onMobileToggle();
      return;
    }

    // Special handling for settings item to open modal
    if (item.id === 'settings' && userRole === 'individual') {
      dispatch(settingTrue(true));
      onMobileToggle();
      // setShowSettingsModal(true)
      return;
    }

    // Mobile-specific handling for nonprofit items
    if (isMobile && userRole === 'nonprofit') {
      if (item.id === 'donations' && onMobileManageDonations) {
        onMobileManageDonations();
        onMobileToggle();
        return;
      }
      if (item.id === 'store' && onMobileManageStore) {
        onMobileManageStore();
        onMobileToggle();
        return;
      }
      if (item.id === 'wishlist' && onMobileManageWishlist) {
        onMobileManageWishlist();
        onMobileToggle();
        return;
      }
    }

    if (item.external && item.path) window.open(item.path, '_blank');
    else if (item.path) history.push(item.path);

    if (window.innerWidth <= 991.98) onMobileToggle();
  };

  return (
    <>
      <div className={`sidebar ${collapsed ? 'collapsed' : ''} ${mobileOpen ? 'mobile-open' : ''} ${isMobile ? 'sidebar-drawer' : ''}`}>
        <div className="sidebar-header">
          <Link to='/' className='sidebar-header-link'>
            <div className="logo-container">
              <div className="logo-circle">
                <span className="logo-text">NEDDIE</span>
              </div>
              {!collapsed && <span className="brand-text">neddie.co</span>}
            </div>
          </Link>
          <button
            className="mobile-close-btn mobile-only"
            onClick={onMobileToggle}
            aria-label="Close menu"
          >
            ✕
          </button>
        </div>

        <nav className="sidebar-nav">
          <ul className="nav-list">
            {navigationItems.map((item) => {
              return (
                item?.disable ?
                  <li key={item.id} className={`nav-item ${item.disable ? 'disable' : ''}`}>
                    <button
                      className={`nav-link ${item.disable ? 'disable' : ''} ${item.active ? 'active' : ''} ${item.hasSubmenu ? 'has-submenu' : ''} ${openDropdowns.has(item.id) ? 'submenu-open' : ''} `}
                      onClick={() => handleNavClick(item)}

                      title={collapsed ? item.label : ''}
                    >
                      <span className="nav-icon">{item.icon}</span>
                      {!collapsed && <span className="nav-label" >{item.label}</span>}
                      {!collapsed && item.hasSubmenu && (
                        <FontAwesomeIcon icon={faChevronDown} className={`dropdown-arrow ${openDropdowns.has(item.id) ? 'open' : ''}`} />
                      )}
                      {!collapsed && item.external && !item.hasSubmenu && (
                        <FontAwesomeIcon icon={faExternalLinkAlt} className="external-icon" />
                      )}
                    </button>
                    {item.hasSubmenu && !collapsed && openDropdowns.has(item.id) && (
                      <ul className="submenu-list">
                        {item.subitems?.map((subitem) => (
                          <li key={subitem.id} className="submenu-item">

                            <button
                              className={`submenu-link ${subitem.active ? 'active' : ''}`}
                              onClick={() => {
                                if (subitem.external && subitem.path) window.open(subitem.path, '_blank');
                                else if (subitem.path) history.push(subitem.path);
                                if (window.innerWidth <= 991.98) onMobileToggle();
                              }}
                              title={collapsed ? subitem.label : ''}

                            >
                              <span className="submenu-label">{subitem.label}</span>
                              {subitem.external && (
                                <FontAwesomeIcon icon={faExternalLinkAlt} className="external-icon" />
                              )}
                            </button>
                          </li>
                        ))}
                      </ul>
                    )}
                      <span className='span-c-s'>
                        Coming soon
                      </span>
                  </li>
                  :
                  <li key={item.id} className="nav-item">
                    <button
                      className={`nav-link ${item.disable ? 'disable' : ''} ${item.active ? 'active' : ''} ${item.hasSubmenu ? 'has-submenu' : ''} ${openDropdowns.has(item.id) ? 'submenu-open' : ''} `}
                      onClick={() => handleNavClick(item)}

                      title={collapsed ? item.label : ''}
                    >
                      <span className="nav-icon">{item.icon}</span>
                      {!collapsed && <span className="nav-label" >{item.label}</span>}
                      {!collapsed && item.hasSubmenu && (
                        <FontAwesomeIcon icon={faChevronDown} className={`dropdown-arrow ${openDropdowns.has(item.id) ? 'open' : ''}`} />
                      )}
                      {!collapsed && item.external && !item.hasSubmenu && (
                        <FontAwesomeIcon icon={faExternalLinkAlt} className="external-icon" />
                      )}
                    </button>
                    {item.hasSubmenu && !collapsed && openDropdowns.has(item.id) && (
                      <ul className="submenu-list">
                        {item.subitems?.map((subitem) => (
                          <li key={subitem.id} className="submenu-item">

                            <button
                              className={`submenu-link ${subitem.active ? 'active' : ''}`}
                              onClick={() => {
                                if (subitem.external && subitem.path) window.open(subitem.path, '_blank');
                                else if (subitem.path) history.push(subitem.path);
                                if (window.innerWidth <= 991.98) onMobileToggle();
                              }}
                              title={collapsed ? subitem.label : ''}

                            >
                              <span className="submenu-label">{subitem.label}</span>
                              {subitem.external && (
                                <FontAwesomeIcon icon={faExternalLinkAlt} className="external-icon" />
                              )}
                            </button>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>

              )
            }
            )}
          </ul>
        </nav>

        <div className="sidebar-footer">
          {userRole === 'individual' && (
            <>
              <button
                className="nav-link footer-link"
                onClick={() => window.open('https://www.neddieblog.com/faqs', '_blank')}
                title={collapsed ? 'Help' : ''}
              >
                <span className="nav-icon"><FontAwesomeIcon icon={faQuestionCircle} className="fa-fw" /></span>
                {!collapsed && <span className="nav-label">Help</span>}
                {!collapsed && <FontAwesomeIcon icon={faExternalLinkAlt} className="external-icon" />}
              </button>

              <button
                className="nav-link footer-link"
                onClick={() => window.open('https://www.neddieblog.com/contact', '_blank')}
                title={collapsed ? 'Contact Us' : ''}
              >
                <span className="nav-icon"><FontAwesomeIcon icon={faEnvelope} className="fa-fw" /></span>
                {!collapsed && <span className="nav-label">Contact Us</span>}
                {!collapsed && <FontAwesomeIcon icon={faExternalLinkAlt} className="external-icon" />}
              </button>
            </>
          )}

          <button
            className="nav-link logout-btn"
            onClick={logout}
            title={collapsed ? 'Log Out' : ''}
          >
            <span className="nav-icon">{png('/icons/14.png', 'Log Out')}</span>
            {!collapsed && <span className="nav-label">Log Out</span>}
          </button>
        </div>
      </div>

      {/* Donor Profile Modal */}
      <DonorProfile
        show={showDonorProfileModal}
        hide={handleCloseDonorProfileModal}
      />


      {/* Settings Modal */}
      <SettingsModal
        show={setting}
        onSave={handleSaveSettings}
      />
    </>
  );
};

export default Sidebar;
